var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from '@emotion/styled';
import MuiAlert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import Fade from '@mui/material/Fade';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { theme } from '../../../globals';
var getTextColor = function (_a) {
    var type = _a.type, theme = _a.theme;
    return getColor({ type: type, theme: theme, property: 'color' });
};
var getBackgroundColor = function (_a) {
    var type = _a.type, theme = _a.theme;
    return getColor({ type: type, theme: theme, property: 'backgroundColor' });
};
var getColor = function (_a) {
    var type = _a.type, theme = _a.theme, property = _a.property;
    var colorMap = {
        error: {
            color: '#d0021b',
            backgroundColor: theme.colors.backgroundDanger,
        },
        success: {
            color: '#417505',
            backgroundColor: theme.colors.success,
        },
        warning: {
            color: '#663c00',
            backgroundColor: theme.colors.warning,
        },
        info: {
            color: '#0d3c61',
            backgroundColor: theme.colors.info,
        },
    };
    if (!colorMap[type] || !colorMap[type][property]) {
        return 'inherit';
    }
    return colorMap[type][property] || 'inherit';
};
var NotificationWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: ", ";\n"], ["\n  position: ", ";\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: ", ";\n"])), function (_a) {
    var fixed = _a.fixed;
    return (fixed ? 'fixed' : 'relative');
}, function (_a) {
    var zIndex = _a.zIndex;
    return zIndex;
});
var NotificationStyled = styled(MuiAlert)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  border-radius: 0;\n  font-size: 0.93rem;\n  font-family: ", ";\n  letter-spacing: 0;\n  color: ", ";\n  background-color: ", ";\n  .MuiAlert-action {\n    position: absolute;\n    right: 1.4rem;\n    cursor: pointer;\n    color: #195d8d;\n    font-size: 1.3rem;\n  }\n"], ["\n  width: 100%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  border-radius: 0;\n  font-size: 0.93rem;\n  font-family: ", ";\n  letter-spacing: 0;\n  color: ", ";\n  background-color: ", ";\n  .MuiAlert-action {\n    position: absolute;\n    right: 1.4rem;\n    cursor: pointer;\n    color: #195d8d;\n    font-size: 1.3rem;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var type = _a.type, theme = _a.theme;
    return getTextColor({ type: type, theme: theme });
}, function (_a) {
    var type = _a.type, theme = _a.theme;
    return getBackgroundColor({ type: type, theme: theme });
});
/**
  Global notification component.
  Any extra props will be passed down to the underlying Material UI Alert component.
*/
export var Notification = function (_a) {
    var children = _a.children, _b = _a.show, show = _b === void 0 ? true : _b, _c = _a.type, type = _c === void 0 ? 'error' : _c, _d = _a.fixed, fixed = _d === void 0 ? true : _d, _e = _a.animationTimeout, animationTimeout = _e === void 0 ? 500 : _e, _f = _a.closeBtnAnimationTimeout, closeBtnAnimationTimeout = _f === void 0 ? { enter: 1200, exit: 250 } : _f, onClose = _a.onClose, _g = _a.zIndex, zIndex = _g === void 0 ? 1600 : _g, props = __rest(_a, ["children", "show", "type", "fixed", "animationTimeout", "closeBtnAnimationTimeout", "onClose", "zIndex"]);
    var renderCloseIcon = function () {
        return (<Fade in={show} timeout={closeBtnAnimationTimeout}>
        <div>
          <FontAwesomeIcon data-testid={"close-".concat(type, "-alert")} onClick={onClose} icon={faTimesCircle}/>
        </div>
      </Fade>);
    };
    return (<NotificationWrapper fixed={fixed} zIndex={zIndex}>
      <Collapse in={show} timeout={animationTimeout}>
        <NotificationStyled icon={false} action={onClose && renderCloseIcon()} type={type} theme={theme} data-testid={"".concat(type, "-alert")} {...props}>
          {children}
        </NotificationStyled>
      </Collapse>
    </NotificationWrapper>);
};
var templateObject_1, templateObject_2;
